import { handleActions } from "redux-actions";
import { AUTHENTICATION } from "constants/action-types";

export interface IState {
    error: any;
    postingForgotPassword: boolean;
    forgotPasswordSuccess: boolean;
}

const initialState: any = {
    error: undefined,
    postingForgotPassword: false,
    forgotPasswordSuccess: false,
};

export const authentication = handleActions(
    {
        [AUTHENTICATION.FORGOT_PASSWORD.START]: (state: IState, { error }: any): IState => {
            return {
                ...state,
                postingForgotPassword: true,
            };
        },
        [AUTHENTICATION.FORGOT_PASSWORD.COMPLETED]: (state: IState, { error, payload }: any): IState => {
            if (error) {
                return {
                    ...state,
                    error: payload,
                    postingForgotPassword: false,
                    forgotPasswordSuccess: false,
                };
            }
            return {
                ...state,
                forgotPasswordSuccess: true,
                postingForgotPassword: false,
            };
        },
        [AUTHENTICATION.FORGOT_PASSWORD.RESET]: () => {
            return {
                ...initialState,
            };
        },
    },
    initialState,
);
